let _fpPromise = null;
let _cached = null;

const STORAGE_KEY = "colygon_device_fingerprint";

/**
 * Returns a stable device fingerprint string. The library is loaded lazily
 * (only when signing in) so it stays out of the initial bundle. Cached in
 * localStorage so repeated logins from the same browser produce the same
 * value (soft-bind).
 */
export const getDeviceFingerprint = async () => {
  if (_cached) return _cached;
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) {
      _cached = stored;
      return stored;
    }
  } catch {
    /* localStorage might be blocked */
  }
  if (!_fpPromise) {
    _fpPromise = import(/* webpackChunkName: "fingerprint" */ "@fingerprintjs/fingerprintjs")
      .then(({ default: FingerprintJS }) => FingerprintJS.load());
  }
  try {
    const fp = await _fpPromise;
    const result = await fp.get();
    _cached = result.visitorId;
    try { localStorage.setItem(STORAGE_KEY, _cached); } catch { /* ignore */ }
    return _cached;
  } catch {
    _fpPromise = null; // p. ej. sin red al pedir el chunk: se reintenta la próxima vez
    return null;
  }
};
